import { createSelector } from 'reselect';
import { selectIsMultipleEnabled, getWidgetConfig } from 'root/selectors';
import {
  selectTabIsIdSelected,
  selectTabReachedMaxSelectionWithContext,
  getListMultipleIdsInRange,
  selectTabAvailableUntilMax,
} from '../../common/selectors';
import consts from '../data/consts';

const TAB = 'gdrive';

const selectReachedMaxSelection = selectTabReachedMaxSelectionWithContext(TAB);
const selectIsIdSelected = selectTabIsIdSelected(TAB);
const selectAvailableUntilMax = selectTabAvailableUntilMax(TAB);

const selectGoogleDrive = (state) => state.gdrive;

const selectCurrentContext = createSelector(selectGoogleDrive, (gdrive) => gdrive.currentContext);

const selectSearchTerm = createSelector(selectGoogleDrive, (gdrive) => gdrive.lists[consts.CONTEXTS.SEARCH].params.term);

const selectUser = createSelector(selectGoogleDrive, (gdrive) => gdrive.user);

const selectIsSignedIn = createSelector(selectGoogleDrive, (gdrive) => gdrive.isSignedIn);

const selectTabData = createSelector(
  selectIsMultipleEnabled,
  selectUser,
  selectIsSignedIn,
  selectCurrentContext,
  (isMultiple, user, isSignedIn, currentContext) => ({
    isMultiple,
    user,
    isLoggedIn: isSignedIn,
    currentContext,
  })
);

const selectConfigClientId = createSelector(getWidgetConfig, (config) => config.googleDriveClientId);

const selectPanelOpen = createSelector(selectGoogleDrive, (gdrive) => gdrive.panelIsOpen);

const selectSort = createSelector(selectGoogleDrive, (gdrive) => gdrive.sort);

const selectOrderBy = createSelector(selectGoogleDrive, (gdrive) => gdrive.orderBy);

const selectIsSearch = createSelector(selectCurrentContext, (context) => context === consts.CONTEXTS.SEARCH);

const selectListFiles = createSelector(selectGoogleDrive, selectCurrentContext, (gdrive, context) => gdrive.lists[context].files);

const getLists = createSelector(selectGoogleDrive, (gdrive) => gdrive.lists);

const selectMultipleIdsInRange = createSelector(
  getLists,
  selectListFiles,
  (lists, listFiles) => (id, context) =>
    getListMultipleIdsInRange(
      {
        ...lists[context],
        items: listFiles.data,
      },
      id
    )
);

const selectSelectedIds = createSelector(getLists, selectCurrentContext, (lists, context) => lists[context].selected);

const selectBreadcrumbsPath = createSelector(selectGoogleDrive, (gdrive) => gdrive.breadcrumbPath);

const selectIsFetchingUploadData = createSelector(selectGoogleDrive, (grdive) => grdive.fetchingUploadData);

const selectIsWaitingForSignIn = createSelector(selectGoogleDrive, (grdive) => !grdive.userNotLoggedIn && grdive.waitForSignIn);

export {
  selectGoogleDrive,
  selectBreadcrumbsPath,
  selectTabData,
  selectIsIdSelected,
  selectReachedMaxSelection,
  selectCurrentContext,
  selectMultipleIdsInRange,
  selectAvailableUntilMax,
  selectConfigClientId,
  selectPanelOpen,
  selectSort,
  selectOrderBy,
  selectIsSearch,
  selectListFiles,
  selectSelectedIds,
  selectSearchTerm,
  selectIsFetchingUploadData,
  selectUser,
  selectIsWaitingForSignIn,
};
